<template>
  <div class="modal fade" id="session-timeout-dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          <h4 class="modal-title">SESSION TIMEOUT NOTIFICATION</h4>
        </div>
        <div class="modal-body">
          <p>Your session is about to expire.</p>
          <p>Redirecting in <span class="countdown-holder">{{ secondsToSessionEnd }}s</span> seconds.</p>
          <div class="progress">
            <div class="progress-bar progress-bar--yellow progress-bar-striped countdown-bar active" role="progressbar" :style="progressBarStyles">
              <span class="countdown-holder">{{ secondsToSessionEnd }}s</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button id="session-timeout-dialog-logout" type="button" class="btn default" @click="emitLogout">Logout</button>
          <button id="session-timeout-dialog-keepalive" type="button" class="btn green" data-dismiss="modal" @click="emitRefresh">Stay Connected</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from "../../config/app"

  export default {
    name: "SessionTimeoutModal",
    props: {
      secondsToSessionEnd: {
        type: [Number],
        required: false
      }
    },
    computed: {
      progressBarPercentage(){
        if (!this.secondsToSessionEnd || this.secondsToSessionEnd > config.sessionSecondsLeftToShowModal){
          return 100;
        }
        return 100 - (((-config.sessionSecondsLeftToShowModal) + this.secondsToSessionEnd) / config.sessionSecondsLeftToShowModal * -100)
      },
      progressBarStyles(){
        return {
          'min-width': '15px',
          width: `${this.progressBarPercentage}%`
        }
      }
    },
    methods: {
      emitLogout(){
        this.$emit('logout')
      },
      emitRefresh(){
        this.$emit('refresh')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SessionTimeoutModal.vue?00840c28